export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6747.a4f8bd9e.jpg";